import React from 'react';
import { AlertTriangleIcon, CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { purchaseUrl } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const included = ['5 Módulos completos: Principiante, Intermedio, Avanzado, Por Edades y Adultos Mayores', 'BONO 1 — Banco de 85 clases (gratis)', 'BONO 2 — Biblioteca de 155 combinaciones (gratis)', 'BONO 3 — Guía completa de adaptación (gratis)', 'Garantía de 7 días sin preguntas'];
export function Pricing() {
  return <section id="pricing" className="scroll-mt-20 bg-canvas px-4 py-14 md:py-16" aria-labelledby="pricing-title" data-id="element-198" data-mp="6bnylux1mq5y">
      <div className="mx-auto max-w-2xl text-center" data-id="element-199" data-mp="abf0ato3yqp9">
        <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-primary md:text-sm" data-id="element-200" data-mp="2r1lnzt6ed56o">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-4" data-id="element-201" data-mp="2v4a1ie62309z">
          <Countdown data-id="element-202" data-mp="2fncex7itzg8y" />
        </div>
        <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-red-200 bg-red-50 px-4 py-2 text-xs font-extrabold text-red-600" data-id="element-203" data-mp="2fonh52wmofxy">
          <AlertTriangleIcon className="h-4 w-4" data-id="element-204" data-mp="2ooal9wgqrzup" />
          Después sube $5.000 ARS. No vuelve.
        </p>

        <article className="mt-8 rounded-3xl border-4 border-primary bg-white p-6 text-left shadow-[0_24px_60px_rgba(219,39,119,.20)] md:p-9" data-id="element-205" data-mp="2kmxe9j1wxqm7">
          <div className="text-center" data-id="element-206" data-mp="2yl5hg8pjlo5t">
            <span className="inline-flex rounded-full bg-primary px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-207" data-mp="2yk3vh96znh9b">
              📘 Combo Completo Jumping 2026
            </span>
            <h2 id="pricing-title" className="mt-4 text-xl font-black text-ink md:text-3xl" data-id="element-208" data-mp="33d6q7kni4wr3">
              5 Módulos + 3 Bonos GRATIS
            </h2>
          </div>

          <ul className="my-7 space-y-2.5 border-y border-pink-100 py-6" data-id="element-209" data-mp="3hd7rh17oi673">
            {included.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-slate-700" data-id="element-210" data-mp="3cbs7zdl5g7qt">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-211" data-mp="29ym5wblumume" />
                {item}
              </li>)}
          </ul>

          <div className="text-center" data-id="element-212" data-mp="2j02hunsbb4sq">
            <p className="text-base font-bold text-slate-400 line-through" data-id="element-213" data-mp="2iz0srfegohs0">$117.990</p>
            <p className="text-[11px] font-extrabold uppercase tracking-wide text-slate-500" data-id="element-214" data-mp="2nt51o47aezvq">Hoy</p>
            <p className="text-4xl font-black text-primary md:text-6xl" data-id="element-215" data-mp="2sqoqtz5iwx2g">$19.990 ARS</p>
            <div className="mt-6" data-id="element-216" data-mp="2xoqd0sy8xci5">
              <Button href={purchaseUrl} fullWidth className="text-sm md:text-lg" data-id="element-217" data-mp="2xruma4qkiyfo">
                🏃‍♀️ QUIERO MI COMBO JUMPING AHORA →
              </Button>
            </div>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-slate-500" data-id="element-218" data-mp="36pwryxl8yf9a">
              <span className="flex items-center gap-1" data-id="element-219" data-mp="1ccf2v6571ac5">
                <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-220" data-mp="1ccylkp2o42r8" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-221" data-mp="14ugvp8ahibc3">
                <ZapIcon className="h-3.5 w-3.5 text-primary" data-id="element-222" data-mp="10279o3chpvf3" /> Acceso en 5 minutos
              </span>
              <span className="flex items-center gap-1" data-id="element-223" data-mp="v2kzy3vvexb1">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-224" data-mp="v0zzxyqsem5s" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-225" data-mp="1ns1k6e9c77w6">
                <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-226" data-mp="1nri4l475svlb" /> Mercado Pago · Tarjeta ·
                Transferencia
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}